import React from 'react';
import baseStyles from '../form-field-base.module.css';
import MultiSelectFilter from '../MultiSelectFilter/MultiSelectFilter';
import type { MultiSelectOption } from '../MultiSelectFilter/MultiSelectFilter';
import styles from './FormMultiSelect.module.css';

interface FormMultiSelectProps {
  id?: string;
  label?: string;
  error?: string;
  required?: boolean;
  values: string[];
  onChange: (values: string[]) => void;
  options: MultiSelectOption[];
  placeholder?: string;
  searchPlaceholder?: string;
  disabled?: boolean;
  containerClassName?: string;
  className?: string;
  noResultsText?: string;
  clearButtonLabel?: string;
}

const FormMultiSelect: React.FC<FormMultiSelectProps> = ({
  id,
  label,
  error,
  required = false,
  values,
  onChange,
  options,
  placeholder = 'Selecione...',
  searchPlaceholder = 'Pesquisar',
  disabled = false,
  containerClassName = '',
  className = '',
  noResultsText = 'Nenhum resultado encontrado',
  clearButtonLabel = 'Limpar seleção',
}) => {
  const triggerClassName = [
    styles.trigger,
    error ? styles.triggerError : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={`${baseStyles.fieldGroup} ${containerClassName}`.trim()}>
      {label && (
        <label htmlFor={id} className={baseStyles.label}>
          {label}
          {required && <span className={baseStyles.required}>*</span>}
        </label>
      )}
      <MultiSelectFilter
        values={values}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        disabled={disabled}
        className={triggerClassName}
        wrapperClassName={styles.wrapper}
        noResultsText={noResultsText}
        clearButtonLabel={clearButtonLabel}
        hideChips
        chipsInTrigger
        showSelectionCount={false}
      />
      {error && <span className={baseStyles.errorText}>{error}</span>}
    </div>
  );
};

export default FormMultiSelect;
